"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.giftCardReasonCodes = exports.getGiftCardErrorMessage = exports.giftCardErrors = exports.DEFAULT_GIFT_CARD_ERROR = void 0;
var get_message_1 = require("./get-message");
var constants_1 = require("./constants");
exports.DEFAULT_GIFT_CARD_ERROR = 'Unable to process gift card.';
exports.giftCardErrors = new Map([
    [
        'S013',
        {
            source: constants_1.SOURCES.PAYMENTS,
            ecomm: 'Regala is currently unavailable. Please use a different method of payment.',
            pos: 'Regala is currently unavailable. Please use a different method of payment.',
        },
    ],
]);
function getGiftCardErrorMessage(errCode, defaultMsg) {
    if (defaultMsg === void 0) { defaultMsg = exports.DEFAULT_GIFT_CARD_ERROR; }
    return (0, get_message_1.getMessage)(exports.giftCardErrors, defaultMsg, errCode);
}
exports.getGiftCardErrorMessage = getGiftCardErrorMessage;
exports.giftCardReasonCodes = Array.from(exports.giftCardErrors.keys());
